import styled from "styled-components";

export const FailWrapper = styled.div`
  width: fit-content;
  font-size: 47px;
  color: ${({ theme }) => {
    return theme.colors.red;
  }};
  margin: auto;
`;
